import React from "react";
import "./Ourclient.css";
import { Container } from "react-bootstrap";
import firstImg from "../../../Asset/ourclient/Matt-transformed-1.svg";
import secondImg from "../../../Asset/ourclient/david.svg";
import thirdImg from "../../../Asset/ourclient/florian-hellburg.svg";
import fourthImg from "../../../Asset/ourclient/debbie-manchur.svg";
import fifthImg from "../../../Asset/ourclient/trueman.svg";
import upwork from "../../../Asset/ourclient/image-84.svg";
import clutch from "../../../Asset/ourclient/Group.svg";
import envelop from "../../../Asset/ourclient/Frame-290524.svg";
import stars from "../../../Asset/ourclient/star.svg";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { useNavigate } from "react-router-dom";

const Ourclient = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="our-client-section">
        <Container>
          <div className="top-text-ourclient">
            <h2>
              OUR CLIENT'S <span>WORD</span>
            </h2>
          </div>
          <div className="testimonial_inner">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="testimonial_boxs wide_box">
                  <div className="img_text_part">
                    <div className="img_part">
                      <img alt="card" src={firstImg}></img>
                    </div>
                    <div className="text_part">
                      <h3>Mathew Abar</h3>
                      <p>CEO of Finfolio</p>
                    </div>
                  </div>
                  <div className="content_part">
                    <p className="content_p">
                      <ReactReadMoreReadLess
                        charLimit={200}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                        readMoreClassName="read-more"
                        readLessClassName="read-more"
                      >
                        Codeffi Team did a great job for us over 2 full years.
                        They have great attention to detail and built some
                        amazing screens for our material design app. Highly
                        recommended.
                      </ReactReadMoreReadLess>
                    </p>
                  </div>
                  <div className="bottom_part">
                    <div className="left">
                      <p>Industry</p>
                      <h6>Financial Services</h6>
                    </div>
                    <div className="right">
                      <div className="upwork-img">
                        <img alt="card" src={upwork}></img>
                      </div>
                      <div className="stars-part">
                        <img alt="card" src={stars}></img>
                        <span>5/5</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="testimonial_boxs wide_box">
                  <div className="img_text_part">
                    <div className="img_part">
                      <img alt="card" src={secondImg}></img>
                    </div>
                    <div alt="card-image" className="text_part">
                      <h3>David Scott</h3>
                      <p>
                        Chief Operating Officer at ShipTime Canada Inc. & Paid
                        Inc.
                      </p>
                    </div>
                  </div>
                  <div className="content_part">
                    <p className="content_p">
                      <ReactReadMoreReadLess
                        charLimit={204}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                        readMoreClassName="read-more"
                        readLessClassName="read-more"
                      >
                        Wow, our new website is finally complete, and we
                        couldn't be more thrilled! The entire process took just
                        a month, thanks to the incredible teamwork and
                        dedication from everyone involved. It was amazing to see
                        how each team member brought their unique skills and
                        enthusiasm to the table.
                      </ReactReadMoreReadLess>
                    </p>
                  </div>
                  <div className="bottom_part">
                    <div className="left">
                      <p>Industry</p>
                      <h6>Saas</h6>
                    </div>
                    <div className="right">
                      <div className="upwork-img">
                        <img alt="card" src={envelop}></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="testimonial_boxs wide_box">
                  <div className="img_text_part">
                    <div className="img_part">
                      <img alt="card" src={thirdImg}></img>
                    </div>
                    <div className="text_part">
                      <h3>Florian Hellberg</h3>
                      <p>CTO of ProgressMaker</p>
                    </div>
                  </div>
                  <div className="content_part">
                    <p className="content_p">
                      <ReactReadMoreReadLess
                        charLimit={114}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                        readMoreClassName="read-more"
                        readLessClassName="read-more"
                      >
                        The Angular coding and results have a very high
                        standard. Excellent at solving requirements, dealing
                        with complex frontend web applications and APIs, and
                        understands the tasks very well.
                      </ReactReadMoreReadLess>
                    </p>
                  </div>
                  <div className="bottom_part">
                    <div className="left">
                      <p>Industry</p>
                      <h6>Enterprise Solution</h6>
                    </div>
                    <div className="right">
                      <div className="upwork-img">
                        <img alt="card" src={upwork}></img>
                      </div>
                      <div className="stars-part">
                        <img alt="card" src={stars}></img>
                        <span>5/5</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="testimonial_boxs wide_box">
                  <div className="img_text_part">
                    <div className="img_part">
                      <img alt="card" src={fourthImg}></img>
                    </div>
                    <div className="text_part">
                      <h3>Debbie Manchur</h3>
                      <p>Officer at Semiahmoo Yacht Club</p>
                    </div>
                  </div>
                  <div className="content_part">
                    <p className="content_p">
                      <ReactReadMoreReadLess
                        charLimit={131}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                        readMoreClassName="read-more"
                        readLessClassName="read-more"
                      >
                        I was recently involved in a project to add
                        functionality to a website for a social club, built on
                        WordPress. I had spoken to a few developers and chose to
                        work with Codeffi. They are excellent to work with, very
                        professional and produce quality results.
                      </ReactReadMoreReadLess>
                    </p>
                  </div>
                  <div className="bottom_part">
                    <div className="left">
                      <p>Industry</p>
                      <h6>Hospitality</h6>
                    </div>
                    <div className="right">
                      <div className="upwork-img">
                        <img alt="card" src={clutch}></img>
                      </div>
                      <div className="stars-part">
                        <img alt="card" src={stars}></img>
                        <span>5/5</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="testimonial_boxs wide_box">
                  <div className="img_text_part">
                    <div className="img_part">
                      <img alt="card" src={fifthImg}></img>
                    </div>
                    <div className="text_part">
                      <h3>Michael Trueman</h3>
                      <p>Founder of Parcelport</p>
                    </div>
                  </div>
                  <div className="content_part">
                    <p className="content_p">
                      <ReactReadMoreReadLess
                        charLimit={116}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                        readMoreClassName="read-more"
                        readLessClassName="read-more"
                      >
                        We have been working with Codeffi since the inception of
                        our company four years ago and they have been
                        instrumental in helping us build our core business
                        applications. They have been great team players, working
                        collaboratively to help turn our business requirements
                        into working software solutions.
                      </ReactReadMoreReadLess>
                    </p>
                  </div>
                  <div className="bottom_part">
                    <div className="left">
                      <p>Industry</p>
                      <h6>Logistics</h6>
                    </div>
                    <div className="right">
                      <div className="upwork-img">
                        <img alt="card" src={envelop}></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="arrow-row">
              <p className="btn" onClick={() => navigate("/testimonials")}>
                <span>View All</span>
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1.49867 7.83594L14.487 7.83594L10.0762 12.2468C9.99737 12.3238 9.93464 12.4158 9.89162 12.5172C9.8486 12.6187 9.82613 12.7277 9.82552 12.8379C9.82492 12.9482 9.84618 13.0574 9.88808 13.1593C9.92999 13.2613 9.9917 13.3539 10.0696 13.4318C10.1476 13.5098 10.2402 13.5715 10.3422 13.6133C10.4441 13.6552 10.5534 13.6765 10.6636 13.6759C10.7738 13.6752 10.8828 13.6527 10.9843 13.6097C11.0857 13.5667 11.1777 13.5039 11.2547 13.4251L17.088 7.59177C17.2443 7.4355 17.332 7.22358 17.332 7.0026C17.332 6.78163 17.2443 6.56971 17.088 6.41344L11.2547 0.580105C11.1774 0.502573 11.0855 0.441086 10.9844 0.399183C10.8833 0.35728 10.7748 0.335786 10.6653 0.335938C10.5005 0.335974 10.3395 0.384867 10.2025 0.476437C10.0654 0.568007 9.95866 0.698143 9.8956 0.850393C9.83254 1.00264 9.81604 1.17017 9.84818 1.3318C9.88032 1.49343 9.95966 1.6419 10.0762 1.75844L14.487 6.16927L1.49867 6.16927C1.27765 6.16927 1.06569 6.25707 0.909412 6.41335C0.753132 6.56963 0.665335 6.78159 0.665335 7.00261C0.665335 7.22362 0.753132 7.43558 0.909412 7.59186C1.06569 7.74814 1.27765 7.83594 1.49867 7.83594Z" />
                </svg>
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Ourclient;
